import { CheckoutStyleTokens } from "./checkout.tokens";

export const CheckoutStyles: CheckoutStyleTokens = {
    submitButton: {
        color: "success"
    }
};
